interface IAovRecord {
  campaignName: string
  value: number
}

export function findAovValue(aovs: IAovRecord[] | undefined, campaignName: string): number {
  if (!aovs) {
    return 0
  }

  const normalizedName = campaignName.toLowerCase()
  const exactMatch = aovs.find((aov) => aov.campaignName.toLowerCase() === normalizedName)
  const partialMatch = aovs.find((aov) => normalizedName.includes(aov.campaignName.toLowerCase()))

  return (exactMatch ?? partialMatch)?.value || 0
}
